import { render, staticRenderFns } from "./PaniereOrderDetailsDialog.vue?vue&type=template&id=1871a4f8&scoped=true"
import script from "./PaniereOrderDetailsDialog.vue?vue&type=script&lang=js"
export * from "./PaniereOrderDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1871a4f8",
  null
  
)

export default component.exports